import { TSalesManager } from '@internal/services/TSalesManager';
import {
    NoResultsContact,
    NoResultsTips,
} from '@renderer-ui-library/molecules';
import { Grid } from '@renderer-ui-library/mui';
import { MachineType } from '@internal/utils/machine/MachineType';
import { TLocale } from '@internal/utils/machine/i18n/TLocale';
import Head from 'next/head';
import React from 'react';
import styles from './noResults.module.scss';

interface Props {
    machineType: MachineType | undefined;
    salesManager: TSalesManager | null;
    locale: TLocale;
}

export const NoResults: React.FC<Props> = React.memo(
    ({ salesManager, locale }) => {
        return (
            <>
                <Head>
                    <meta name="robots" content="noindex, follow" />
                </Head>
                <div className={styles.container}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={7}>
                            <NoResultsTips />
                        </Grid>
                        {salesManager && (
                            <Grid item xs={12} lg={5}>
                                <NoResultsContact
                                    contact={salesManager}
                                    locale={locale}
                                />
                            </Grid>
                        )}
                    </Grid>
                </div>
            </>
        );
    },
);

NoResults.displayName = 'NoResults';
